import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import './ToggleSwitch.scss';

const ToggleSwitch = ({ id, className, active, handleClick, activeText, inactiveText }) => {
  const [focused, setFocused] = useState(false);

  const classNames = cn('cp-toggle-switch', className);
  const sliderClassNames = cn('toggle-switch__slider', {
    'toggle-switch__slider--active': active
  });

  return (
    <label className={classNames} htmlFor={id} data-focused={focused}>
      <input
        checked={active}
        type="checkbox"
        id={id}
        onChange={handleClick}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <span className={sliderClassNames} />
      <span className="toggle-switch__text">{active ? activeText : inactiveText}</span>
    </label>
  );
};

ToggleSwitch.defaultProps = {
  activeText: <FormattedMessage id="on" />,
  inactiveText: <FormattedMessage id="off" />
};

ToggleSwitch.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  activeText: childrenShape,
  inactiveText: childrenShape
};

export default ToggleSwitch;
